import { Button } from '@jouzen/ecom-components/v3/Button';
import { useTranslations } from 'next-intl';

import {
  type PDPContextType,
  usePDPContext,
} from '@/app/[locale]/product/_contexts/PDPProvider';

import BundleStep from '../_components/Modals/BundleModal/BundleStep';
import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import WizStepId from './enums/WizStepId';
import { useStepCTA } from './hooks/useStepCTA';
import { getHref } from './utils/getHref';

const StepCTA = () => {
  const {
    currentRoute,
    currentStep,
    isAccessory,
    nextButtonDisabled,
    isAddingToCart,
  } = useWizardStateContext();
  const { getFirstStockedFinish }: PDPContextType = usePDPContext();
  const step = useStepCTA();
  const { ctaMsgKey } = step;

  const isBundleStepOR3 = !isAccessory && currentStep === WizStepId.Size;
  const t = useTranslations();
  const href = getHref({
    currentRoute,
    currentStep,
    getFirstStockedFinish,
  });

  return (
    <>
      {/* add to cart CTA logic is handled in the bundle step for rings */}
      {isBundleStepOR3 ? (
        <BundleStep />
      ) : (
        <Button
          aria-disabled={nextButtonDisabled}
          disabled={nextButtonDisabled}
          loading={isAddingToCart}
          size="large"
          href={!step.isLink ? undefined : href}
          {...step.buttonProps}
        >
          {t(ctaMsgKey)}
        </Button>
      )}
    </>
  );
};

export default StepCTA;
